
import { defineComponent, computed } from 'vue-demi';
import { EstimatedType } from '@tt4b/ttam-enums';
import i18n  from '@/i18n';
const name = 'audienceSize';
export default defineComponent({
  name,
  components: {},
  props: {
    loadingETA: {
      type: Boolean,
      default: false,
    },
    userCount: {
      type: String,
      default: '',
    },
    estimateType: {
      type: Number,
      default: 6,
    }
  },
  setup(props) {
    const label = computed(() => {
      const labelEnums = {
        [EstimatedType.TOO_NARROW]: i18n.t('audience_estimate_gear_too_narrow'),
        [EstimatedType.NARROW]: i18n.t('audience_estimate_gear_narrow'),
        [EstimatedType.BALANCED]: i18n.t('audience_estimate_gear_balanced'),
        [EstimatedType.FAIRLY_BROAD]: i18n.t('audience_estimate_gear_fairly_broad'),
        [EstimatedType.BROAD]: i18n.t('audience_estimate_gear_broad'),
      };
      return labelEnums[props.estimateType] ?? '';
    });

    const labelStyleConfig = {
      [EstimatedType.TOO_NARROW]: { color: '#CA242E', background: '#FFF2F0' },
      [EstimatedType.NARROW]: { color: '#8D670B', background: '#FDF5DA' },
      [EstimatedType.BALANCED]: { color: '#057E33', background: '#E7FDE8' },
      [EstimatedType.FAIRLY_BROAD]: { color: '#057E33', background: '#E7FDE8' },
      [EstimatedType.BROAD]: { color: '#057E33', background: '#E7FDE8' },
    };
    const labelStyle = computed(() => labelStyleConfig[props.estimateType] ?? {});

    return {
      name,
      labelStyle,
      label,
    };
  },
});
